import { render, staticRenderFns } from "./TournamentSignupManagement.vue?vue&type=template&id=32bd6c50&"
import script from "./TournamentSignupManagement.vue?vue&type=script&lang=js&"
export * from "./TournamentSignupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports